module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_PHILIPS.54fe95c3.png";